
import { ERP } from '../_base/endpoint';
import axios from 'axios';

import global from '../../common/utility/global';

class arqueoCajaService {

    /******* QUERIES ******/


    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/arqueo-caja/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerResumenId(id) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-apertura/resumen/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-apertura/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async Getcorrelativo() {
        const response = await axios
            .get(`${ERP}tesoreria/caja-apertura/correlativo`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async Getefectivo() {
        const response = await axios
            .get(`${ERP}tesoreria/caja-apertura/efectivo`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerAnexoId(filter) {
        const response = await axios
        .get(`${ERP}tesoreria/arqueo-caja/anexoLista?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };



    
    async excelAnexo(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/arqueo-caja/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };




    async excel(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-apertura/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-apertura/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    
    async pdfPrint(id) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-apertura/resumen/pdf?id=${id}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    /******* TRANSACCIONES ******/



    async registrarCajaAjuste(data) {
        const response = await axios
            .post(`${ERP}tesoreria/arqueo-caja/ajuste`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

 
}

export default new arqueoCajaService();